import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import {
  checkIcon,
  flecheDroiteIcon,
  telechargerIcon,
} from "../../../assets/svgs/icons/icons.svg";
import InformationEtabRecap from "../../../components/etablissement/recapitulatif/InformationEtabRecap/InformationEtabRecap";
import PossibilitesAccueilsEtabRecap from "../../../components/etablissement/recapitulatif/PossibilitesAccueilsEtabRecap/PossibilitesAccueilsEtabRecap";
import Button from "../../../components/global/Button/Button";
import LinkButton from "../../../components/global/Button/LinkButton/LinkButton";
import {
  IEtablissement,
  Metier,
  TypeEtablissement,
} from "../../../schemas-and-types/etablissement/etablissemen.schema";
import { useEtablissementStore } from "../../../stores/etablissement/etablissement.store";

import FooterBackGroundImage from "../../../assets/png/error-page-decoration.png";
import { scrollToAnchor } from "../../../utils";
import styles from "./EtablissementDemandeEnvoyePage.module.scss";
import useTranslation from "../../../hooks/useTranslation";

export default function EtablissementDemandeEnvoyePage() {
  const { t } = useTranslation();
  const etablisement = useEtablissementStore((state) => state.etablissement);
  // * react-to-print
  const componentToPrintRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentToPrintRef.current,
  });

  useEffect(() => {
    scrollToAnchor(document.getElementById("demande-envoyee-anchor"));
  }, []);
  return (
    <article
      id="demande-envoyee-anchor"
      className={styles.etablissementDemandeEnvoyePage}
    >
      <header className={styles.etablissementDemandeEnvoyePage__header}>
        <section>
          <figure>{checkIcon}</figure>
          <h1>{t('establishment.requestSent.title')}</h1>
        </section>
        <p>
          {t('establishment.requestSent.confirmation')}
        </p>
      </header>
      <main className={styles.etablissementDemandeEnvoyePage__main}>
        <section
          className={
            styles.etablissementDemandeEnvoyePage__main__topButtonSection
          }
        >

        </section>
        <section ref={componentToPrintRef}>
          <InformationEtabRecap
            canUpdate={false}
            // etablissement={etablissementData?.data as IEtablissement}
            etablissement={etablisement as IEtablissement}
          />
          <PossibilitesAccueilsEtabRecap
            canUpdate={false}
            // metiers={etablissementData?.data?.metiers as Metier[]}
            metiers={etablisement?.metiers as Metier[]}

            typeEtablissement={etablisement?.type as TypeEtablissement}
          />
        </section>
 
        <LinkButton
          to={"/"}
          text={t('common.backToHome')}
          iconRight={flecheDroiteIcon}
        />
      </main>
      <footer
        style={{ backgroundImage: `url(${FooterBackGroundImage})` }}
      ></footer>
    </article>
  );
}
